export default {
  getLayers: state => {
    return state.layersById.map(layer_id => state.layers[layer_id]);
  },
  // get the list of all activeLayers
  getActiveLayers: state => {
    return state.activeLayers;
  },

  getLayerByLevel: (state, getters) => level => {
    return getters.getLayers.filter(layer => layer.layerLevel === level);
  },

  getActiveLayerByLevel: (state, getters) => level => {
    return getters.getActiveLayers[level];
  },
};
